const classNameWarning = "bg-yellow-200 border-yellow-400";
const classNameError = "bg-red-200 border-red-400";
const classNameSuccess = "bg-green-200 border-green-400";

const Notification = ({ type, children }) => {
  const getClassName = () => {
    if (type === "warning") {
      return classNameWarning;
    }
    if (type === "error") {
      return classNameError;
    }
    if (type === "success") {
      return classNameSuccess;
    }
  };
  return (
    <>
      <div
        className={`${getClassName()} mb-2 mt-2 border-l-4 rounded-md w-full px-4 py-2`}
      >
        {children}
      </div>
    </>
  );
};

export default Notification;
